export default "__VITE_ASSET__jNvO9wUG__"